<template>
<div>
  <div class="options-bar">
    <el-button type="primary" size="mini" v-if="ERP.isPermission(3004001001)" @click="showEditor(1, 0)" icon="el-icon-plus">新增个人客户</el-button>
    <el-button type="primary" size="mini" v-if="ERP.isPermission(3004001002)" @click="showEditor(2, 0)" icon="el-icon-plus">新增企业客户</el-button>
    <el-button type="primary" size="mini" v-if="ERP.isPermission(3004001003)" @click="getExcel" >导出业户模板</el-button>
    <el-button type="primary" size="mini" v-if="ERP.isPermission(3004001004)" @click="pushExcel" >导入业户模板</el-button>
    <!--        <el-button type="primary" size="mini" @click="customerBinding" >未绑定客户房产</el-button>-->
    <el-button type="primary" size="small" @click="$router.push({path: 'Customer/CustomerBinding'})">未绑定客户房产</el-button>
  </div>

  <!--      <el-card class="box-card search-wrap mt-10">-->
  <el-collapse v-model="searchActiveNames">
    <el-collapse-item title="查询条件" name="1">

      <div class="search-condition">
        <el-descriptions :column="2" size="mini" border :label-style="{width: '120px'}" :content-style="{width: 'calc( 90%/2 - 300px)'}">
          <el-descriptions-item label="客户">
<!--            <el-input size="mini" v-model="searchFrom.name" clearable placeholder="请输入客户名称" style="width: 400px;"></el-input>-->
            <autocomplete-customer
              v-model="searchFrom.name"
              :project_id="mainObj.organization_project_id"
              :class_tx="0"
              @select="search()"
              @clear="search()"
              style="width: 400px;"
            />
          </el-descriptions-item>
          <el-descriptions-item label="所属组织">
            <!--                  <el-input size="mini" v-model="searchFrom.organization"></el-input>-->
            <el-select v-model="mainObj.organization_project_id" clearable filterable placeholder="所属组织">
              <el-option
                v-for="item in project_list"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </el-descriptions-item>
          <el-descriptions-item label="房号">
            <el-autocomplete size="mini"
                             style="min-width: 400px;max-width: 100%"
                             v-model="mainObj.room_name"
                             :fetch-suggestions="querySearchAsyncRoom"
                             placeholder="请输入房产"
                             popper-class="autocomplete-room"
            ></el-autocomplete>
            <el-button size="mini" type="primary" icon="el-icon-office-building" @click="showHouseTree()"></el-button>
          </el-descriptions-item>
          <el-descriptions-item label="客户性质">
            <el-checkbox-group size="mini" v-model="searchFrom.class">
              <el-checkbox label="1">个人客户</el-checkbox>
              <el-checkbox label="2">企业客户</el-checkbox>
            </el-checkbox-group>
          </el-descriptions-item>
          <el-descriptions-item label="联系电话">
            <el-input size="mini" v-model="searchFrom.contact_number" clearable placeholder="请输入联系电话" style="width: 400px;"></el-input>
          </el-descriptions-item>
          <el-descriptions-item label="客户类型">
            <!--                  <el-checkbox-group size="mini" v-model="searchFrom.type">-->
            <!--                    <el-checkbox label="1">业主</el-checkbox>-->
            <!--                    <el-checkbox label="2">租户</el-checkbox>-->
            <!--                    <el-checkbox label="3">住户</el-checkbox>-->
            <!--                    <el-checkbox label="4">共有人</el-checkbox>-->
            <!--                    <el-checkbox label="5">开发商</el-checkbox>-->
            <!--                    <el-checkbox label="9">其它</el-checkbox>-->
            <!--                  </el-checkbox-group>-->
            <el-select v-model="searchFrom.type" clearable filterable multiple placeholder="其它类型">
              <el-option label="业主" value="1"></el-option>
              <el-option label="租户" value="2"></el-option>
              <el-option label="住户" value="3"></el-option>
              <el-option label="共有人" value="4"></el-option>
              <el-option label="开发商" value="5"></el-option>
              <el-option label="其它" value="9"></el-option>
            </el-select>
          </el-descriptions-item>
<!--          <el-descriptions-item label="车牌号码">-->
<!--            <el-input size="mini" v-model="searchFrom.plate" disabled style="width: 400px;"/>-->
<!--          </el-descriptions-item>-->
          <el-descriptions-item label="家庭成员电话">
            <el-input size="mini" v-model="searchFrom.family_member_number" placeholder="请输入家庭成员电话"></el-input>
          </el-descriptions-item>
          <el-descriptions-item label="客户房产关系">
            <el-select size="mini" v-model="searchFrom.house_status" filterable clearable multiple placeholder="请选择客户房产关系">
              <el-option v-for="(item,index) in type_list" :key="index" :value="item.id" :label="item.name"></el-option>
            </el-select>
          </el-descriptions-item>
          <el-descriptions-item label="家庭成员">
            <el-input size="mini" v-model="searchFrom.family_member" style="width: 400px;"></el-input>
          </el-descriptions-item>
          <el-descriptions-item label="最后更新操作员">
            <el-input size="mini" v-model="searchFrom.operator"></el-input>
          </el-descriptions-item>
          <el-descriptions-item label="最后更新时间">
            <!--                      <el-date-picker v-model="searchFrom.update_time" value-format="yyyy-MM-dd" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>-->
            <el-date-picker
              v-model="searchFrom.update_time_start"
              type="date"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              clearable
              placeholder="选择时间" size="mini">
            </el-date-picker>
            <el-date-picker
              v-model="searchFrom.update_time_end"
              type="date"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              clearable
              placeholder="选择时间" size="mini">
            </el-date-picker>
          </el-descriptions-item>
          <el-descriptions-item label="">
            <el-button type="primary" size="mini" @click="search()" :loading="searchLoading">查询</el-button>
            <el-button size="mini" @click="resetForm('searchForm')">重置</el-button>
          </el-descriptions-item>
        </el-descriptions>

        <!--              <el-form :model="searchFrom" ref="searchForm" size="mini" label-width="120px" >-->
        <!--                <el-row :gutter="20">-->
        <!--                  &lt;!&ndash; LEFT &ndash;&gt;-->
        <!--                  <el-col :span="12">-->
        <!--                    &lt;!&ndash; <el-form-item label="客户编码" prop="customer_code">-->
        <!--                      <el-input v-model="searchFrom.customer_code" disabled></el-input>-->
        <!--                    </el-form-item> &ndash;&gt;-->
        <!--                  </el-col>-->

        <!--                  &lt;!&ndash; RIGHT &ndash;&gt;-->
        <!--                  <el-col :span="10">-->
        <!--                  </el-col>-->
        <!--                </el-row>-->
        <!--              </el-form>-->

      </div>

    </el-collapse-item>
  </el-collapse>

  <!--      </el-card>-->

  <div class="data-list mt-15">
    <el-link type="danger">更新数： {{pageTotal}} 条 </el-link>
    <el-table v-loading="searchLoading" :data="pageData.data" border style="width: calc(100vw - 200px)" ref="customerTable" :key="tableKey">
      <el-table-column prop="id" label="ID" width="70" fixed></el-table-column>
      <el-table-column prop="name" label="客户名称" align="center" width="120" fixed>
        <template slot-scope="scope">
          <el-link type="primary" @click="showEditor(scope.row.class, scope.row.id)">{{scope.row.name}}</el-link>
        </template>
      </el-table-column>
      <!-- <el-table-column prop="" label="客户编码" width=""></el-table-column> -->
      <el-table-column prop="credentials_code" label="证件号码" width="180" align="center"></el-table-column>
      <!--          <el-table-column label="客户性质" width="80" align="center">-->
      <!--            <template slot-scope="scope">-->
      <!--              <span>{{getClassName(scope.row.class)}}</span>-->
      <!--            </template>-->
      <!--          </el-table-column>-->
      <el-table-column prop="organization_name" label="归属项目" width="120" align="center"></el-table-column>
      <el-table-column label="客户类型" width="80" align="center">
        <template slot-scope="scope">
          <span>{{getTypeNames(scope.row.type)}}</span>
        </template>
      </el-table-column>
      <el-table-column label="当前房产关系" width="100" align="center">
        <template slot-scope="scope">

          <span>{{scope.row.customer_house_status}}</span><el-link type="primary" v-if="ERP.isPermission(3004001005)&&scope.row.house_id&&!scope.row.is_able_status" @click="changeStatus(scope.row)" icon="el-icon-edit" style="margin-left: 5px;"></el-link>
          <!--              <el-select v-if="scope.row.house_id&&scope.row.is_able_status" v-model="scope.row.status" placeholder="请选择业户关系" size="mini" @change="changeStatus(scope.row)">-->
          <!--                <el-option-->
          <!--                  v-for="item in type_list"-->
          <!--                  :key="item.id"-->
          <!--                  :label="item.name"-->
          <!--                  :value="item.id">-->
          <!--                </el-option>-->
          <!--              </el-select>-->

        </template>
      </el-table-column>
      <el-table-column label="历史账单" width="100" align="center">
        <template slot-scope="scope">
          <span title="欠费账单/所有账单">{{scope.row.order_count}}/{{scope.row.all_order_count}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="contact_number" label="手机/联系电话" width="100" align="center"></el-table-column>
      <el-table-column prop="" label="主房产" width="360" align="center">
        <template slot-scope="scope">
          {{scope.row.house_name}}
          <!--              <el-link type="primary" v-if="scope.row.house_id" @click="showXscCustomerWind({house_id:scope.row.house_id})">查看新视窗</el-link>-->
        </template>
      </el-table-column>
      <el-table-column label="最后更新时间" width="100" align="center">
        <template slot-scope="scope">
          <span>{{timeFormat(scope.row.update_time, false)}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="operator" label="操作员" width="100" align="center"></el-table-column>
      <el-table-column prop="" label="操作" width="300" align="center" fixed="right">
        <template slot-scope="scope">
          <!--              <el-button type="primary" size="mini" @click="showEditor(scope.row.class, scope.row.id)">校准</el-button>-->
          <el-button type="primary" size="mini" icon="el-icon-edit" @click="showEditor(scope.row.class, scope.row.id)">编辑</el-button>
          <!--              <el-button type="danger" size="mini" icon="el-icon-delete" @click="deleteCustomer(scope.row.id)">删除</el-button>-->
          <el-button type="danger" size="mini" icon="el-icon-delete" v-if="ERP.isPermission(3004001007)" @click="deleteCustomerHouse(scope.row.customer_house_id)">移除关系</el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="block pagination">
      <el-pagination background layout="prev, pager, next" :total="pageData.total" :page-size="pageData.per_page" :current-page="pageData.current_page" @current-change="changePage"></el-pagination>
    </div>

  </div>

  <!-- 编辑器 -->
  <editor v-model="visable" :classValue="classValue" :id="id" :type_arr="[1,2,3,4,9]" @callback="callback(arguments)"></editor>

  <ShowXscCustomer ref="showXscCustomerRef" />
  <SelectCustomerHouseStatus ref="selectCustomerHouseStatusRef" />
</div>
</template>

<script>
import SelectCustomerHouseStatus from "../SelectCustomerHouseStatus";
import ShowXscCustomer from "../ShowXscCustomer";
import Common from "../../common";
import Http from "../../common/Http";
import AutocompleteCustomer from "../common/autocompleteCustomer";

export default {
  name: "ListMain",
  components: {
    AutocompleteCustomer,
    SelectCustomerHouseStatus,
    ShowXscCustomer,
    'editor': () => import('../../editor.vue'),
    'erp-tree-status': () => import('../../../Common/erp-tree-status.vue'),
  },
  inject: ['mainObj','toggleHouseTree'],
  data(){
    return{
      searchFrom: {
        name: '',
        room_name: '',
        room_id: 0,
        contact_number: '',
        plate: '',
        family_member: '',
        update_time: '',
        update_time_start:"",
        update_time_end:"",
        customer_code: '',
        organization: '',
        class: [],
        type: [],
        customer_card_number: '',
        family_member_number: '',
        operator: '',
        organization_project_id:"",
        house_status: [],
      },
      customerList: [],
      pageData:{
        page: 1,
        per_page: 10,
        data:[],
        total:0
      },
      id: 0,
      visable: false,
      classValue: 0,
      pageTotal: 0,
      pageSize: 10,
      page: 1,
      tableKey: 1,
      searchLoading: false,
      searchActiveNames:"1",
      type_list:[
        {"id": 1, "name": "业主/租户", "type_id": 15},
        {"id": 2, "name": "业主/历史租户", "type_id": 14},
        {"id": 3, "name": "业主", "type_id": 12},
        {"id": 4, "name": "历史业主/租户", "type_id": 11},
        {"id": 5, "name": "历史业主/历史租户", "type_id": 10},
        {"id": 6, "name": "历史业主", "type_id": 8},
        {"id": 7, "name": "租户", "type_id": 3},
        {"id": 8, "name": "历史租户", "type_id": 2}
      ],
      project_list:[],
    }
  },
  mounted() {
    this.getProjectList();
    this.getList();
  },
  watch: {
    page(val) {
      this.getList()
    },
  },
  methods: {
    getList() {
      const that=this;
      this.searchLoading = true
      let params = Object.assign({}, {
        ...that.searchFrom,
        ...that.mainObj,
      })

      ERP.postRequest({
        url:`admin/Customer/getList2?page=${that.pageData.page}&per_page=${that.pageData.per_page}`,
        data:params
      },ret=>{
        that.searchLoading = false
        if(ret.code) {
          that.pageData = ret.data;
          this.pageTotal = ret.data.total
        }
      })
    },
    timeFormat: Common.timeFormat,
    getClassName: Common.getClassName,
    getTypeNames(val) {
      if(!val){
        return ''
      }
      let arr = Common.getTypeNames(val)
      return arr.join(', ')
    },
    deleteCustomer(customerId) {
      this.$confirm('此操作将删除此客户, 是否继续?', '提示', {confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning'}).then(() => {
        this.$myhttp.post('admin/Customer/delete?customer_id='+customerId).then(backdata => {
          let res = backdata.data
          if(res.code == 200) {
            this.$message.success('删除成功!');
            this.getList()
          } else {
            this.$message.error('删除失败！');
          }
        })
      })
    },
    deleteCustomerHouse(customer_house_id) {
      this.$confirm('此操作将删除此客户与房产间的关系, 是否继续?', '提示', {confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning'}).then(() => {
        ERP.postRequest({
          url:"admin/CustomerHouse/delete",
          data:{id:customer_house_id}
        },ret=>{
          if(ret.code) {
            this.$message.success('删除成功!');
            this.getList()
          } else {
            this.$message.error('删除失败！');
          }
        })
      })
    },
    changePage(i) {
      this.pageData.page = i
      this.getList()
    },
    search() {
      this.pageData.page = 1
      this.getList()
    },
    showEditor(_class, id) {
      this.classValue = _class
      this.id = id
      this.visable = true
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    callback(arg) {
      this.getList()
      if(arg && arg[0]) this.id = arg[0]
    },
    showHouseTree() {
      this.toggleHouseTree()
      this.tableKey += 1
    },
    querySearchAsyncRoom(queryString, cb){
      if(!queryString){
        cb([]);
      }else {
        ERP.postRequest({
          url:"admin/Customer/getHouseList",
          data:{keyWord:queryString}
        },ret=>{
          if(ret.code) {
            cb(ret.data)
          }
        })
      }

    },
    getExcel2(){
      const that=this;
      if(!that.mainObj.room_name){
        that.$message.error('请选择房产或项目')
        return false;
      }
      that.$confirm('用户数据批量导入，是存在风险的操作行为，请操作人员了解清楚：批量不结转订单，不做售楼，不改变房态，不改变收费对象！修改了数据很大可能无法恢复数据（建议新增的项目采用此模式，其余不建议），您确定采用批量导入吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        ERP.showLoading()
        ERP.postRequest({
          url:"admin/CustomerExcel/houseCustomer",
          data:{house_name:that.mainObj.room_name}
        },ret=>{
          ERP.hideLoading()
          if(ret.code){
            window.open(__HTTP__.defaults.baseURL +ret.data)
          }
        })
      })

    },
    getExcel(){
      const that=this;
      if(!that.mainObj.organization_project_id){
        that.$message.error('请选择房产或项目(归属组织)')
        return false;
      }
      that.$confirm('用户数据批量导入，是存在风险的操作行为，请操作人员了解清楚：批量不结转订单，不做售楼，不改变房态，不改变收费对象！修改了数据很大可能无法恢复数据（建议新增的项目采用此模式，其余不建议），您确定采用批量导入吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        ERP.showLoading()
        ERP.postRequest({
          url:"admin/CustomerHouse/exportHouseCustomerBind",
          data:{project_id:that.mainObj.organization_project_id}
        },ret=>{
          ERP.hideLoading()
          if(ret.code){
            window.open(ret.data)
          }else {
            that.$message.error(ret.msg);
          }
        })
      })

    },
    pushExcel2(){
      const that=this;
      if(!that.mainObj.room_name){
        that.$message.error('请选择房产或项目')
        return false;
      }
      that.$confirm('用户数据批量导入，是存在风险的操作行为，请操作人员了解清楚：批量不结转订单，不做售楼，不改变房态，不改变收费对象！修改了数据很大可能无法恢复数据（建议新增的项目采用此模式，其余不建议），您确定采用批量导入吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        Http.uploadFile(_file=>{
          ERP.showLoading()
          ERP.postRequest({
            url:"admin/CustomerExcel/importHouseCustomer",
            data:{file:_file}
          },ret=>{
            ERP.hideLoading()
            if(ret.code){
              that.$message.success('Excel表单导入成功');
              that.$alert("已导入修改数据："+ret.data.user_count)
            }else {
              that.$message.error('Excel表单导入失败');
            }
          })
        })
      })
    },
    pushExcel(){
      const that=this;
      if(!that.mainObj.organization_project_id){
        that.$message.error('请选择房产或项目(归属组织)')
        return false;
      }
      that.$confirm('用户数据批量导入，是存在风险的操作行为，请操作人员了解清楚：批量不结转订单，不做售楼，不改变房态，不改变收费对象！修改了数据很大可能无法恢复数据（建议新增的项目采用此模式，其余不建议），您确定采用批量导入吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        Http.uploadFile(_file=>{
          ERP.showLoading()
          ERP.postRequest({
            url:"admin/CustomerHouse/importHouseCustomerBind",
            data:{file:_file,project_id:that.mainObj.organization_project_id}
          },ret=>{
            ERP.hideLoading()
            if(ret.code){
              that.$message.success('Excel表单导入成功');
              that.$alert("已导入修改数据："+ret.data.length)
            }else {
              that.$message.error('Excel表单导入失败');
            }
          })
        })
      })
    },
    getProjectList(){
      const that=this;
      ERP.getRequest({
        url:"admin/Project/getProjectList",
        data:{}
      },ret=>{
        if(ret.code){
          that.project_list=ret.data;
        }
      })
    },
    showXscCustomerWind(obj){
      const that=this;
      that.$refs.showXscCustomerRef.show(obj)
    },
    changeStatus(item){
      const that=this;
      that.$refs.selectCustomerHouseStatusRef.show(item,_item=>{
        // item=_item;
        that.getList();
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../common.scss";

.pagination {
  margin: 10px 0;
  display: flex;
  justify-content: center;
}

.data-list {
  overflow: auto;
}

.autocomplete-room{
  width: 500px;
}

.search-wrap{
  width: calc(100vw - 200px);
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Customer/components/list/ListMain.vue